"use client";

import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import SortIcon from "@/app/_components/Icons/SortIcon";
import TickCircle from "@/app/_components/Icons/TickCircle";
import { Close, Inbox } from "@mui/icons-material";
import {
  Box,
  Chip,
  Collapse,
  Grow,
  Icon,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import React from "react";
import { useSiteSearchContext } from "./SiteSearchContext";

type Props = {
  nextBtnDisabled?: boolean;
  prevBtnDisabled?: boolean;
};

export default function MobileSortChip(props: Props) {
  const { nextBtnDisabled, prevBtnDisabled } = props;
  const { sortItems, activeSort, handleSortChange, isPending } = useSiteSearchContext();
  const [open, setOpen] = React.useState(false);
  const activeItem = activeSort ? sortItems.find((a) => a.value == activeSort) : null;
  return (
    <>
      <Chip
        variant="outlined"
        onClick={() => {
          setOpen(true);
        }}
        label={
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Collapse in={!prevBtnDisabled} orientation="horizontal">
              <Icon sx={{ fontSize: 14 }}>
                <SortIcon />
              </Icon>
            </Collapse>
            <Collapse in={prevBtnDisabled} orientation="horizontal">
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body2">{activeItem ? activeItem.name : "مرتب سازی"}</Typography>
                <Icon sx={{ fontSize: 14 }}>
                  <Arrow2DownIcon />
                </Icon>
              </Box>
            </Collapse>
          </Box>
        }
      ></Chip>

      <SwipeableDrawer
        ModalProps={{
          keepMounted: false,
          slotProps: {},
          sx: {
            "& .MuiPaper-root": {
              height: "70vh",
              borderTopLeftRadius: 4 * 4,
              borderTopRightRadius: 4 * 4,
            },
          },
        }}
        anchor={"bottom"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onOpen={() => {}}
        disableDiscovery={true}
        hysteresis={0}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
      >
        <Stack>
          <Stack>
            <Grow in={isPending}>
              <LinearProgress variant="indeterminate" color="secondary" />
            </Grow>
          </Stack>
          <Stack direction={"row"} sx={{ mt: 1 }} alignItems={"center"} justifyContent={"center"}>
            <Box width={"45px"} height={"5px"} sx={{ borderRadius: 50, backgroundColor: "grey.100" }}></Box>
          </Stack>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
            <Typography variant="h4">مرتب سازی بر اساس</Typography>
            <IconButton
              onClick={() => {
                setOpen(false);
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <List>
            {sortItems.map((item, index) => {
              const active = Boolean(activeSort && activeSort === item.value);
              return (
                <ListItem key={index} sx={{ py: 0.5 }}>
                  <ListItemButton
                    disabled={isPending}
                    selected={active}
                    onClick={() => {
                      handleSortChange(item.value);
                      setOpen(false);
                    }}
                    sx={(t) => ({
                      borderRadius: 3,
                      "&.Mui-selected": {
                        ...(active && { backgroundColor: `${(t.palette as any).secondary["50"]} !important` }),
                      },
                    })}
                  >
                    <ListItemIcon sx={{ minWidth: "auto", mr: 1 }}>
                      <Icon color="secondary">{active && <TickCircle />}</Icon>
                    </ListItemIcon>
                    <Typography component={"span"} variant="body1">
                      {item.name}
                    </Typography>
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Stack>
      </SwipeableDrawer>
    </>
  );
}
